import { render, staticRenderFns } from "./PurchaseTableSortable.vue?vue&type=template&id=2bcc8219&scoped=true"
import script from "./PurchaseTableSortable.vue?vue&type=script&lang=js"
export * from "./PurchaseTableSortable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTableSortable.vue?vue&type=style&index=0&id=2bcc8219&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc8219",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bcc8219')) {
      api.createRecord('2bcc8219', component.options)
    } else {
      api.reload('2bcc8219', component.options)
    }
    module.hot.accept("./PurchaseTableSortable.vue?vue&type=template&id=2bcc8219&scoped=true", function () {
      api.rerender('2bcc8219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/components/PurchaseTableSortable.vue"
export default component.exports